import { render, staticRenderFns } from "./NotApprovedContent.vue?vue&type=template&id=7b6e14a7&"
import script from "./NotApprovedContent.vue?vue&type=script&lang=js&"
export * from "./NotApprovedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports